import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as _ from "lodash";

require('./bringoz-labels-display.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-labels-display',
  templateUrl: './bringoz-labels-display.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozLabelsDisplayComponent implements OnInit, OnChanges {
  @Input() labels: string[];
  @Input() maxItems: number;

  public viewLabels: string[];
  public extraLabelsCount: number;
  public extraLabels: string[];
  public labelsMap: {};

  constructor(@Inject('splitService') private splitService) {}

  ngOnInit() {
    const siteLabels = this.splitService.getSiteLabels();
    this.labelsMap = {};

    _.forEach(siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
    this.viewLabels = [];
    this._initItems(this.labels);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.labels && !changes.labels.isFirstChange()) {
      this.viewLabels = [];
      this._initItems(this.labels);
    }
  }

  private _initItems(labels: string[]) {
    this.extraLabelsCount = undefined;

    if (_.get(labels, 'length')) {
      this.viewLabels = this.maxItems ? _.filter(labels, (item, index) => {
        return index < this.maxItems;
      }) : labels;

      if (labels.length > this.viewLabels.length) {
        this.extraLabelsCount = (labels.length - this.viewLabels.length);
        this.extraLabels = labels.slice(this.maxItems);
      }

    }
  }



}
